
import { Component, Ref, Vue } from 'vue-property-decorator'
import ManageNoticeEdit from '@/components/templates/manage/ManageNoticeEdit.vue'
import { NotificationsApi } from '@/api/methods/manage/NotificationsApi'
import NoticeUtils from '@/utils/NoticeUtils'

/**
 * お知らせメッセージ登録画面
 */
@Component({
  components: {
    ManageNoticeEdit,
  },
})
export default class AdminNoticeRegist extends Vue {
  /** テンプレート要素 */
  @Ref()
  manageNoticeEdit!: ManageNoticeEdit

  /** 現在日時 */
  private nowDate = new Date()

  /**
   * キャンセルボタン押下時の処理
   */
  private async eventCancel(): Promise<void> {
    await this.$router.push('/admin/notice')
  }

  /**
   * 保存ボタン押下時の処理
   */
  private async eventSubmit(): Promise<void> {
    this.$loading.start()

    // 入力値チェック
    if (!this.checkInputValues()) {
      this.$loading.complete()
      return
    }

    // 登録処理の実行
    const registResponse = await NotificationsApi.createNotification(
      this.manageNoticeEdit.title,
      this.manageNoticeEdit.messageHtml,
      this.manageNoticeEdit.dateTimeRangePicker.startTime / 1000,
      this.manageNoticeEdit.dateTimeRangePicker.endTime / 1000
    )

    this.$loading.complete()
    await this.$router.push(`/admin/notice/${registResponse.id}`)
  }

  /**
   * 入力値チェック
   *
   * @returns 入力値が正常か否か
   */
  private checkInputValues(): boolean {
    // 入力値チェック
    const errorMessage = NoticeUtils.checkNotice(this.manageNoticeEdit.title, this.manageNoticeEdit.messageHtml)
    if (errorMessage) {
      alert(errorMessage)
      return false
    }

    // 期間チェック
    if (!this.manageNoticeEdit.dateTimeRangePicker.isInputed) {
      alert('開始・終了日時を入力してください')
      return false
    }

    return true
  }
}
